import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  Checkbox,
  Grid2,
  useTheme,
} from "@mui/material";
import useLongPress from "../genericComponents/useLongPress";
import Text from "../genericComponents/Text";

const MobileComponent = ({ item, onClick, onSelectedChanged, isSelected }) => {
  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 500,
  };
  const longPressEvent = useLongPress(
    () => onSelectedChanged?onSelectedChanged(item):null,
    () => onClick&&onClick(item),
    defaultOptions
  );
  let content = [];
  if(item)
  for (const [key, value] of Object.entries(item)) {
    if (key == "displayName") continue;
    if (key == "__typename") continue;
    if (key == "id") continue;
    if (key == "uuid") continue;
    content.push(<Text key={key} text={key + " : " + value} align="center" />);
  }
  const theme = useTheme();
  let onClickEvent = {};
  if (onSelectedChanged) {
    onClickEvent = { ...longPressEvent };
  } else if (onClick) {
    onClickEvent = { ...onClick };
  }
  return (
    <Card onClick={()=>!onSelectedChanged&&onClick?onClick(item):null}>
      <AccordionSummary onClick={()=>onSelectedChanged?onSelectedChanged(item):onClick?onClick(item):null}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Checkbox
          sx={{ display: !onSelectedChanged ? "none" : "block" }}
          color="secondary"
          onChange={e=>onSelectedChanged(item)}
          checked={isSelected ? true : false}
        />
        <Text text={item.displayName} align="center" />
      </AccordionSummary>
      <AccordionDetails {...onClickEvent}>      
          {content.map((x) => x)}          
      </AccordionDetails>
    </Card>
  );
};
export default MobileComponent;
